import axios from 'axios';
import { REQUEST_CANCELLED } from './error-handler';
const HttpLib = {
  ...axios,
  ...axios.create()
};

/** Cancels the SourceToken and Create another Token Source */

export const CancelHttpLibToken = (source) => {
  source && source.cancel(REQUEST_CANCELLED);
  source = HttpLib.CancelToken.source();
  return source;
}

export { HttpLib };